/** The URL parameter a discussion link uses to name its message. */
export const COMMENT_LINK_PARAM = 'comment_id';
